import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import axios from 'axios';
import EquipmentProfileAndStatus from './equipmentprofileandstatus';
import CriticalEquipments from './criticalequipments';
import HealthFacility from './healthfacility';
import BreakdownCallReporting from './breakdowncallreporting';
import BreakdownCallCriticalorNonCritical from './breakdowncallcriticalornoncritical';
import RepeatedBreakdownCalls from './repeatedbreakdowncalls';
import HistoricalDysfunctional from './historicaldysfunctional';
import WorkInProgress from './workinprogress';
import PMandCalibration from './pmandcalibration';
import Calibration from './calibrationcallreporting';
import Uptime from './uptime';
import EquipmentCondemnation from './equipmentcondemnation';
import { updateAppState,updateComponentState } from '../actions/actions';

//For Sysmex Branch

import BreakdownCallReportingForSysmex from './breakdowncallreportingforsysmex';
import InstallationWork from './installationwork';

class Dashboard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			manpowercount : 0,
			circularcount : 0,
			loaderflag : true
		};

		this.getTechnicalManPower = this.getTechnicalManPower.bind(this);
		this.onLoad = this.onLoad.bind(this);
		this.usertrainingOnClick = this.usertrainingOnClick.bind(this);
	}

	componentWillMount() {
		this.onLoad();
	}

	onLoad = () => {
		if(localStorage.getItem("pageafterlogin")) {
			let redirectPath = localStorage.getItem("pageafterlogin");
			localStorage.setItem("pageafterlogin", '');
			this.props.history.replace(`${redirectPath}`);
		} else {
			this.getTechnicalManPower();
			this.getCirculars();
		}
	}

	getTechnicalManPower(){
		axios.get(`/api/technicalmanpower`).then((response) => {
			if (response.data.message == 'success') {
				this.setState({
					manpowercount : (response.data.main && response.data.main.length > 0) ? response.data.main.length : 0,
					loaderflag : false
				});
			} else {
				console.log(response);
			}
		});
	}

	getCirculars(){
		axios.get(`/api/circulars`).then((response) => {
			if (response.data.message == 'success') {
				this.setState({
					circularcount : (response.data.main && response.data.main.length > 0) ? response.data.main.length : 0,
					loaderflag : false
				});
			} else {
				console.log(response);
			}
		});
	}

	usertrainingOnClick(){
		if((this.props.app.companyid == 1 && ['Mumbai', 'Mumbai New','Tata'].includes(this.props.app.branch)) || this.props.app.companyid == 7 || this.props.app.companyid == 8) this.props.history.push("/usertrainingbygroup");
		else if(this.props.app.companyid == 1 && ['Sysmex'].includes(this.props.app.branch)) this.props.history.push("/usertrainingbystate");
		else this.props.history.push("/usertrainingbydistrict");
	}

	render() {
		if(!this.props.app || Object.keys(this.props.app).length == 0){
			return null;
		}

		let { manpowercount, circularcount } = this.state;
		let fixed_style_body = {};
		if($(window).outerWidth() > 767) {
			fixed_style_body = {
				marginTop: `${this.props.isModal ? '0' : ((document.getElementsByClassName('header').length > 0 ? document.getElementsByClassName('header')[0].clientHeight : 0) + 3)}px`,
				marginBottom: `${this.props.isModal ? '0' : (document.getElementsByClassName('header').length > 0 ? (document.getElementsByClassName('header')[0].clientHeight - 40) : 40)}px`
			}
		}

		return (
			<div>
				<div className="row">
					<div className="col-lg-5 col-md-6" style={{padding : "8px"}}>
						<div className='dashboarditems cursor-ptr widgetheight'>
							<EquipmentProfileAndStatus history={this.props.history} />
						</div>
					</div>
					{
						(this.props.app.branch != 'Sysmex') ?
							<div className="col-lg-4 col-md-6" style={{padding : "8px"}}>
								<div className='dashboarditems cursor-ptr widgetheight'>
									<CriticalEquipments history={this.props.history} />
								</div>
							</div>
						: null
					}
					
					<div className="col-lg-3 col-md-6" style={{padding : "8px"}}>
						<div className='dashboarditems cursor-ptr widgetheight'>
							<HealthFacility history={this.props.history} />
						</div>
					</div>
					{
						(this.props.app.branch != 'Sysmex') ?
							<div className="col-lg-3 col-md-6" style={{padding : "8px"}}>
								<div className='dashboarditems cursor-ptr widgetheight'>
									<HistoricalDysfunctional history={this.props.history} />
								</div>
							</div>
						: null
					}
					{
						(this.props.app.branch == 'Sysmex') ?
							<div className="col-lg-4 col-md-6" style={{padding : "8px"}}>
								<div className='dashboarditems cursor-ptr widgetheight'>
									<InstallationWork history={this.props.history} />
								</div>
							</div>
						: null
					}
					{
						(this.props.app.branch != 'Sysmex') ?
							<div className="col-lg-3 col-md-6" style={{padding : "8px"}}>
								<div className='dashboarditems cursor-ptr widgetheight'>
									<BreakdownCallReporting history={this.props.history} />
								</div>
							</div>
						: null
					}
					{
						(this.props.app.branch == 'Sysmex') ?
							<div className="col-lg-4 col-md-6" style={{padding : "8px"}}>
								<div className='dashboarditems cursor-ptr widgetheight'>
									<BreakdownCallReportingForSysmex history={this.props.history} />
								</div>
							</div>
						: null
					}
					{
						(this.props.app.branch != 'Sysmex') ?
							<div className="col-lg-4 col-md-6" style={{padding : "8px"}}>
								<div className='dashboarditems cursor-ptr widgetheight'>
									<BreakdownCallCriticalorNonCritical history={this.props.history} />
								</div>
							</div>
						: null
					}
					<div className="col-lg-2 col-md-6" style={{padding : "8px"}}>
						<div className='dashboarditems cursor-ptr widgetheight'>
							<WorkInProgress history={this.props.history} />
						</div>
					</div>
					<div className="col-lg-2 col-md-6" style={{padding : "8px"}}>
						<div className='dashboarditems cursor-ptr widgetheight'>
							<RepeatedBreakdownCalls history={this.props.history} />
						</div>
					</div>
					<div className="col-lg-4 col-md-6" style={{padding : "8px"}}>
						<div className='dashboarditems cursor-ptr widgetheight'>
							<PMandCalibration history={this.props.history} />
						</div>
					</div>
					<div className="col-lg-4 col-md-6" style={{padding : "8px"}}>
						<div className='dashboarditems cursor-ptr widgetheight'>
							<Calibration history={this.props.history} />
						</div>
					</div>
					<div className="col-lg-2 col-md-6" style={{padding : "8px"}}>
						<div className='dashboarditems cursor-ptr widgetheight'>
							<Uptime history={this.props.history} />
						</div>
					</div>
					{
						(this.props.app.branch != 'Sysmex') ?
							<div className="col-lg-3 col-md-6" style={{padding : "8px"}}>
								<div className='dashboarditems cursor-ptr widgetheight'>
									<EquipmentCondemnation history={this.props.history} />
								</div>
							</div>
						: null
					}
					{
						(this.props.app.companyid != 6) ?
							<div className="col-lg-2 col-md-4" style={{padding: "8px"}}>
								<div className="dashboarditems cursor-ptr" style={{width:"100%", display: "flex",alignItems: "center", justifyContent: "space-between",marginRight: "10px", height : "50px", paddingLeft: "15px", paddingRight: "15px"}} onClick={()=>{this.props.history.push("/technicalmanpower")}}>
									<div className="section-header-title"  style={{color:"#008060",float:"left"}}>Technical Manpower</div>
									<div className="section-header-title"  style={{color:"#008060",float:"right"}}>{manpowercount}</div>
								</div>
								{
									(this.props.app.branch == 'Tripura New') ?
										<div className="dashboarditems cursor-ptr" style={{width:"100%", display: "flex",alignItems: "center", justifyContent: "space-between",marginTop : "10px",marginRight: "10px", height : "50px", paddingLeft: "15px", paddingRight: "15px"}} onClick={()=>{this.props.history.push("/circulars")}}>
											<div className="section-header-title"  style={{color:"#008060",float:"left"}}>Circulars</div>
											<div className="section-header-title"  style={{color:"#008060",float:"right"}}>{circularcount}</div>
										</div>
									: null
								}
							</div>
						: null
					}
					{
						(this.props.app.companyid != 6) ?
							<div className="col-lg-2 col-md-3" style={{padding: "8px"}}>
								<div className='dashboarditems cursor-ptr' style={{width:"100%", display: "flex",alignItems: "center",marginRight: "10px", height : "50px", paddingLeft: "15px", paddingRight: "15px"}}>
									<div className="section-header-title"  style={{color:"#405FFF"}} onClick={()=>{this.usertrainingOnClick()}}>{this.props.app.companyid == 7 ? 'Daily Rounds/User Training' : 'User Training'}</div>
								</div>
							</div>
						: null
					}
					{
						(this.props.app.companyid != 6) ?
							<div className="col-lg-2 col-md-3" style={{padding: "8px"}}>
								<div className='dashboarditems cursor-ptr' style={{width:"100%", display: "flex",alignItems: "center",marginRight: "10px", height : "50px", paddingLeft: "15px", paddingRight: "15px"}}>
									<div className="section-header-title"  style={{color:"#405FFF"}} onClick={()=>{this.props.history.push("/customersupport")}}>Customer Support</div>
								</div>
							</div>
						: null
					}
					{
						(this.props.app.companyid != 6) ?
							<div className="col-lg-2 col-md-4" style={{padding: "8px"}}>
								<div className='dashboarditems cursor-ptr' style={{width:"100%", display: "flex",alignItems: "center",marginRight: "10px", height : "50px", paddingLeft: "15px", paddingRight: "15px"}}>
									<div className="section-header-title"  style={{color:"#405FFF"}} onClick={()=>{this.props.history.push("/standardoperatingprocedure")}}>Standard Operating Procedure</div>
								</div>
							</div>
						: null
					}
					{
						(this.props.app.companyid != 6) ?
							<div className="col-lg-1 col-md-3" style={{padding: "8px"}}>
								<div className='dashboarditems cursor-ptr' style={{width:"100%", display: "flex",alignItems: "center",marginRight: "10px", height : "50px", paddingLeft: "15px", paddingRight: "15px"}}>
									<div className="section-header-title" style={{color:"#405FFF"}} onClick={()=>{this.props.history.push("/additionalreports")}}>Billing Reports</div>
								</div>
								{
									(this.props.app.branch == 'Tripura New' && [3327].includes(this.props.app.userid)) ?
										<div className='dashboarditems cursor-ptr' style={{width:"100%", display: "flex",alignItems: "center",marginRight: "10px", height : "50px", paddingLeft: "15px", paddingRight: "15px", marginTop : "10px"}}>
											<a role="button" href={'https://tripura-phase1.bmmp.in/'} data-toggle="tooltip" target="_blank">Old Dashboard</a>
										</div>
									: null
								}
							</div>
						: null
					}
				</div>
			</div>
		);
	}
}

Dashboard = connect(
	(state, props) => {
		let formName = 'dashboard';

		return {
			app : state.app,
			form : formName,
			componentdata: state.componentdata[formName] ? state.componentdata[formName] : null
		}
	}, { updateAppState,updateComponentState }
)(reduxForm()(Dashboard));

export default Dashboard;


// WEBPACK FOOTER //
// ./public/react/components/dashboard.js